import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,

  state: {
    schema: {},
    status: '',
    message: '',
    patientsNpatTotal: '',
  },

  getters: {
    schema: (state) => state.schema,
    status: (state) => state.status,
    message: (state) => state.message,
    patientsNpatTotal: (state) => state.patientsNpatTotal,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    },
    SET_DATA(state, data) {
      state.patientsNpatTotal = data;
    },
    RESET_STATE(state) {
      state.status = '';
      state.message = '';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proPatientsASchema();
        const schema = res.data;

        const resCat1 = await apiClient.catBirthSexes();
        const catBirthSexes = resCat1.data.data;

        const resCat2 = await apiClient.catYear();
        const catYear = resCat2.data.data;

        schema.schemaFormReg2.birth_sexes_birth_sexes_id.items = catBirthSexes;
        schema.schemaFormReg2.users_birth_date_year.items = catYear;

        commit('SET_SCHEMA', schema);
      } catch (error) {
        console.error('Error al cargar schema:', error);
        commit('SET_STATUS', 'error');
        commit('SET_MESSAGE', 'No se pudo cargar el formulario.');
      }
    },

    async save1({ commit }, payload) {
      commit('RESET_STATE');
      try {
        const model = {
          ...payload.model,
          instProfesId: getInstProfesId(),
          typeSave: 1,
        };

        const res = await apiClient.createProPatientsA(model);
        const { success, message } = res.data;

        if (success) {
          commit('SET_STATUS', 'success');
          commit('SET_MESSAGE', message || 'Paciente registrado correctamente.');
        } else {
          commit('SET_STATUS', 'warning');
          commit('SET_MESSAGE', message || 'No se pudo registrar al paciente.');
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Error al registrar paciente.';
        commit('SET_STATUS', 'error');
        commit('SET_MESSAGE', message);
      }
    },

    async save2({ commit }, modelForm) {
      commit('RESET_STATE');
      try {
        const model = {
          modelForm,
          typeSave: 2,
          instProfesId: getInstProfesId(),
        };

        const res = await apiClient.createProPatientsA(model);
        const { message, success, data } = res.data;

        if (success) {
          commit('SET_STATUS', 'success');
          commit('SET_MESSAGE', message || 'Paciente registrado correctamente.');
          commit('SET_DATA', data);
        } else {
          commit('SET_STATUS', 'warning');
          commit('SET_MESSAGE', message || 'No se pudo registrar al paciente.');
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Error al registrar paciente.';
        commit('SET_STATUS', 'error');
        commit('SET_MESSAGE', message);
      }
    },
  },
};
